export default __webpack_public_path__ + "static/media/Taylor_9781408312902.ea65c84d.jpg";